import React from "react";
import {Link} from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import Danger from "components/Typography/Danger.js";



import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import AuthService from "../../services/AuthService";

const useStyles = makeStyles(styles);

export default function ResetPassword(props) {
    const token = props?.match?.params?.token
    const {history} = props;
    const isLoggedIn = props.isLoggedIn;
    const [registerPasswordState, setregisterPasswordState] = React.useState("");
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    const [loginPassword, setLoginPassword] = React.useState('');
    const [confirmationPassword, setConfirmationPassword] = React.useState('');

    React.useEffect(() => {
        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);
        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };
    });

    const resetPassword = () => {
        new AuthService().reset(loginPassword, token)
            .then((data) => {
                console.log('back from login call');
                console.log(data);
                if(data.result == 'success') {
                    alert(data.message);
                    history.push('/auth/login-page')

                }
                else {
                    setLoginPassword('');
                    setConfirmationPassword('');
                    alert(data.message);
                }

            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log(loginPassword)
        console.log(confirmationPassword)

        if(loginPassword == confirmationPassword) {
            resetPassword();
        } else {
            setLoginPassword('');
            setConfirmationPassword('');
        }
    }

    const verifyEmail = (value) => {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    };


    const classes = useStyles();
    return (
        <div className={classes.container}>
            <GridContainer justifyContent="center">
                <GridItem xs={12} sm={6} md={4}>
                    <GridContainer justifyContent="center">
                        <GridItem xs={12} sm={12} md={12}>
                            <h2 align="center">Manufacturing Portal</h2>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <form onSubmit={handleSubmit}>
                                <Card login className={classes[cardAnimaton]}>
                                    <CardHeader
                                        className={`${classes.cardHeader} ${classes.textCenter}`}
                                        color="rose"
                                    >
                                        <h4 className={classes.cardTitle}>RESET</h4>
                                    </CardHeader>
                                    <CardBody>
                                        <CustomInput
                                            success={registerPasswordState === "success"}
                                            error={registerPasswordState === "error"}
                                            labelText="Password"
                                            id="password"
                                            formControlProps={{
                                                fullWidth: true,
                                            }}

                                            inputProps={{
                                                value: loginPassword,
                                                onChange: (event) => {
                                                    setLoginPassword(event.target.value);
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Icon className={classes.inputAdornmentIcon}>
                                                            lock_outline
                                                        </Icon>
                                                    </InputAdornment>
                                                ),
                                                type: "password",
                                                autoComplete: "off",
                                            }}
                                        />
                                        <CustomInput
                                            // success={registerPasswordState === "success"}
                                            // error={registerPasswordState === "error"}
                                            labelText="Confirm Password"
                                            id="confirmationPassword"
                                            formControlProps={{
                                                fullWidth: true,
                                            }}

                                            inputProps={{
                                                value: confirmationPassword,
                                                onChange: (event) => {
                                                    setConfirmationPassword(event.target.value);
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Icon className={classes.inputAdornmentIcon}>
                                                            lock_outline
                                                        </Icon>
                                                    </InputAdornment>
                                                ),
                                                type: "password",
                                                autoComplete: "off",
                                            }}
                                        />


                                    </CardBody>
                                    <CardFooter className={classes.justifyContentCenter}>
                                        <Button size="sm" color="rose"
                                                onClick={handleSubmit}
                                        >Submit</Button>
                                    </CardFooter>
                                </Card>

                            </form>
                        </GridItem>
                    </GridContainer>

                </GridItem>
            </GridContainer>
        </div>
    );
}
